import { NotificationModel } from '@/modules/notification/notification-model';

const { fields } = NotificationModel;

export default [
  fields.id,

  fields.createdAt
];
